<template>
  <div>
    <div v-if="row.info && row.info.date_start && row.info.date_end">
      {{ formatDate(row.info.date_start) }} - {{ formatDate(row.info.date_end) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "bonus-period-column-template",
  components: {},
  props: {
    row: {type: Object, required: true}
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
  },
}
</script>

<style>

</style>